import {MenuPresentationTypes} from '../../constants/menuPresentationTypes';

export const menuPresentation = (state = MenuPresentationTypes.List, action) => {
  switch (action.type) {
    case 'SET_MENU_PRESENTATION':
      return action.data;
    default:
      return state;
  }
};

export const menuGroups = (state = [], action) => {
  switch (action.type) {
    case 'SAVE_MENU_GROUPS':
      return action.data;
    default:
      return state;
  }
};

export const menuItems = (state = [], action) => {
  switch (action.type) {
    case 'SAVE_MENU_ITEMS':
      return action.data;
    case 'STORE_MENU_ITEMS':
      return [...state, ...action.data];
    case 'CLEAR_MENU_ITEMS':
      return [];
    default:
      return state;
  }
};

export const selectedItem = (state = null, action) => {
  switch (action.type) {
    case 'SET_SELECTED_ITEM':
      return action.data;
    case 'CLEAR_SELECTED_ITEM':
      return null;
    // case 'CANCEL_SELECTION':
    //   return null;
    default:
      return state;
  }
};

export const selectedItemSupplements = (state = [], action) => {
  switch (action.type) {
    case 'SET_SELECTED_ITEM_SUPPLEMENTS':
      return action.data;
    case 'CLEAR_SELECTED_ITEM_SUPPLEMENTS':
      return state;
    case 'CANCEL_SELECTION':
      return null;
    default:
      return state;
  }
};

export const selectedItemInstructions = (state = [], action) => {
  switch (action.type) {
    case 'SET_SELECTED_ITEM_INSTRUCTIONS':
      return action.data;
    case 'CANCEL_SELECTION':
      return null;
    default:
      return state;
  }
};

export const selectedBusinessLunch = (state = null, action) => {
  switch (action.type) {
    case 'SET_SELECTED_BUSINESS_LUNCH':
      return action.data;
    case 'CANCEL_SELECTION':
      return null;
    default:
      return state;
  }
};

export const itemsFilter = (state = '', action) => {
  switch (action.type) {
    case 'SET_ITEMS_FILTER':
      return action.term;
    default:
      return state;
  }
};

export const menuItemTypes = (state = [], action) => {
  switch (action.type) {
    case 'STORE_ITEM_TYPES':
      return action.data;
    default:
      return state;
  }
};
